<template>
  <div class="app-container">
    <router-view />
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>
